import React, { useState } from "react";
import { useDisplayModeContext } from "@/app/context/displayModeStore";
import MysnoryLayout from "../../shared/pictureCard/mysnoryLayout";
import ActionTagCard from "./actionTagCard";

interface VariantCardWrapperProps {
  data: any[];
  style: string;
  translations: any;
}

const ActionTagCardWrapper: React.FC<VariantCardWrapperProps> = ({ data, style, translations }) => {
  const { state } = useDisplayModeContext();

  return (
    <MysnoryLayout state={state}>
      {data.map((tag, i) => {
        const currentTagType = tag.numVariants === 1 ? "variant" : "master";
        return (
          <ActionTagCard
            key={i}
            tag={tag}
            style={style}
            state={state}
            translations={translations}
            tagType={currentTagType}
          />
        );
      })}
    </MysnoryLayout>
  );
};

export default ActionTagCardWrapper;
